// Library identifier
export const PATHOLOGICAL_ANATOMY_ID = 'pathological_anatomy'; // Unique identifier for the pathological anatomy module to be used in postgres and keycloak.
export const PATHOLOGICAL_ANATOMY_SHORT = 'pathanat'; // Short name for the pathological anatomy module to be used in role names in keycloak for jwt compression.
